import { FC, Children } from "react";
import { TabPanel, Grid, GridItem } from "@smile2impress/components/relaunch";

import { TwoThreeColumnTabPanelProps } from "./TwoThreeColumnTabPanel.types";

export const TwoThreeColumnTabPanel: FC<TwoThreeColumnTabPanelProps> = ({
    children,
}) => {
    const rows = [];
    const childArray = Children.toArray(children);

    for (let i = 0; i < childArray.length; i += 5) {
        rows.push(childArray.slice(i, i + 2));
        rows.push(childArray.slice(i + 2, i + 5));
    }

    return (
        <TabPanel px={[0, 0, 4]}>
            {rows.map((row, rowIndex) => {
                return row.length ? (
                    <Grid
                        key={`grid-${rowIndex}`}
                        gridTemplateColumns={{
                            base:
                                rowIndex % 2 === 0
                                    ? "repeat(2, 1fr)"
                                    : "repeat(1, 1fr)",
                            tablet: `repeat(${row.length}, 1fr)`,
                        }}
                        gridGap={[1, 1, "76px"]}
                        mb={[1, 1, 4]}
                        _last={{ mb: 0 }}
                    >
                        {row.map((item, itemIndex) => (
                            <GridItem key={`grid-item-${itemIndex}`}>
                                {item}
                            </GridItem>
                        ))}
                    </Grid>
                ) : null;
            })}
        </TabPanel>
    );
};
